import { api } from '@/lib/api/http'

import type { CurrentUserResponse, DirectorySearchResult, User } from '../types'

/** The API answers with the stored record; the UI wants a name it can always render. */
export function toUser(response: CurrentUserResponse): User {
  return {
    id: response.id,
    name: response.displayName ?? response.email,
    email: response.email,
    roles: response.roles,
    status: response.status,
    personId: response.personId,
    personName: response.personName,
    lastSignedInAt: response.lastSignedInAt,
  }
}

export const authApi = {
  /**
   * The caller's portal record, with the Entra access token already attached
   * (see `lib/api/http.ts`). Answers 403 for a valid company token belonging to
   * someone who was never invited — being in the tenant is not access.
   */
  me: () => api.get<CurrentUserResponse>('/users/me').then(toUser),

  /**
   * Any manager or administrator may call this — looking someone up grants nothing by itself. Answers 503
   * when Microsoft Graph is unreachable or not configured; callers should fail soft into manual entry.
   */
  searchDirectory: (query: string, signal?: AbortSignal) =>
    api.get<DirectorySearchResult[]>('/users/directory-search', {
      params: { query },
      ...(signal ? { signal } : {}),
    }),
}
